module.exports = "/_next/static/images/introSectionCard6-b999388f8ccc9f0ec71f0d3264fba81e.svg";